// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { parseDid } from '@zcloak/did-resolver/parseDid';

/**
 * Compare whether two didUrls have the same Uri
 * such as: `did:zk:abcd#key-0` is equal to `did:zk:abcd?query#key-1`
 */
export function isSameUri(didUrl1, didUrl2) {
  const {
    did: did1
  } = parseDid(didUrl1);
  const {
    did: did2
  } = parseDid(didUrl2);
  return did1 === did2;
}
export function isDidUrl(value) {
  if (typeof value !== 'string') return false;
  try {
    parseDid(value);
    return true;
  } catch {
    return false;
  }
}